import { css } from '@emotion/css'

export const container = css`
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
`

export const header = css`
  padding: 10px 0;
  text-align: right;
  border-bottom: 1px solid #182026;
`